import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InspectionReportContext } from 'stores/InspectionReportStore'
import { Modal, Card, FlexView, Icon, Button, LoadingOverlay } from 'components/common'
import { TextArea } from 'components/form'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

const RejectModal = ({ isOpen, onOutsideClick }) => {
  const { t } = useTranslation()
  const history = useHistory()  
  const { rejectReport } = useContext(InspectionReportContext)
  const [loading, setLoading] = useState(false)
  const [comments, setComments] = useState('')

  const onSaveClick = async () => {
    setLoading(true)
    try {      
      await rejectReport(comments)
      toast.success(t('inspectionReportApproval.operationSuccess'))
      history.replace('/inspection-report')
    } catch (error) {
      console.debug(error)
      toast.error(error.errorMessage)
    }    
    setLoading(false)
    onOutsideClick()
  }

  const handleComments = (event) => {
    setComments(event.target.value)
  }  

  return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
    <Card padding="16px" maxWidth="500px" width="80vw">
      <FlexView fontSize="subtitle" fontWeight="bold" flexDirection="row" justifyContent="space-between" alignItems="center" alignSelf="stretch">
        <span>{t('inspectionReportApproval.comments')}</span>
        <Icon name="cross" color="error" width="24px" height="24px" onClick={onOutsideClick} />
      </FlexView>
      <FlexView alignSelf="stretch" margin="8px 0px 0px" height="210px" style={{ overflow: 'auto' }}>
        <TextArea width="100%" rows="8" onChange={handleComments}  ></TextArea>
      </FlexView>
      <FlexView flexDirection="row" justifyContent="flex-end" alignItems="center" alignSelf="stretch">
        <Button margin="0px 0px 8px" color="white" backgroundColor="error" height="39px" onClick={onSaveClick}>{t('inspectionReportApproval.reject')}</Button>
      </FlexView>
    </Card>
    <LoadingOverlay visible={loading} />
  </Modal>
}

export default RejectModal